// extracted by mini-css-extract-plugin
module.exports = {"inner":"popup_inner_316ll","bg":"popup_bg_iaru1","top":"popup_top_2nV24","main":"popup_main_2k0E4","title":"popup_title_14eSV","title2":"popup_title2_1bZNA"};